export default __webpack_public_path__ + "media/zurb/img/home/home-work-britney-21340c490e890fe1b6c149b7937b1090.png";